import { useMutation } from '@tanstack/react-query';
import { queryClient } from '../../..';
import postNotaFiscal from '../queries/postNotaFiscal';

export default function usePostNotaFiscal(onSuccess: () => void) {
  return useMutation((value: any) => postNotaFiscal(value, () => onSuccess()), {
    onSuccess() {
      queryClient.invalidateQueries()
    },
    onError(err: any) {
      console.log(err.message);
    },
  });
}
